import React from 'react'
import { IconToggle } from 'react-mdl'
import EditListPlugin from 'slate-edit-list'

const editorPlugin = EditListPlugin({
  types: ['ol_list', 'ul_list'],
  typeItem: 'list_item',
  typeDefault: 'paragraph',
})
export const { utils, transforms } = editorPlugin

const changeNode = (state, ordered) => {
  const type = ordered ? 'ol_list' : 'ul_list'
  const transform = state.transform()
  // if already list
  if (utils.isSelectionInList(state)) {
    const currentList = utils.getCurrentList(state)
    if (currentList.type === type) {
      // same type then unwind
      transforms.unwrapList(transform)
    } else {
      // different type then toggle
      transform.setNodeByKey(utils.getCurrentList(state).key, type)
    }
  } else {
    // else nest in current type
    transforms.wrapInList(transform, type)
  }

  return transform.focus().apply()
}

const UlButton = ({ state, onChange }) =>
  <IconToggle
    name="format_list_bulleted"
    onChange={() => onChange(changeNode(state, false))}
    checked={
      utils.isSelectionInList(state) &&
      utils.getCurrentList(state).type === 'ul_list'
    }
  />

const OlButton = ({ state, onChange }) =>
  <IconToggle
    name="format_list_numbered"
    onChange={() => onChange(changeNode(state, true))}
    checked={
      utils.isSelectionInList(state) &&
      utils.getCurrentList(state).type === 'ol_list'
    }
  />

const UlNode = ({ children }) =>
  <ul>
    {children}
  </ul>
const OlNode = ({ children }) =>
  <ol>
    {children}
  </ol>
const ItemNode = ({ children }) =>
  <li>
    {children}
  </li>

const Plugin = () => ({
  ...editorPlugin,
  schema: {
    ...editorPlugin.schema,
    nodes: {
      ul_list: UlNode,
      ol_list: OlNode,
      list_item: ItemNode,
    },
  },
})

export { UlButton, OlButton, Plugin as ListPlugin }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/List.js